<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5Z7l3r/tc-custom/9781467778886.jpg?1705234660700" alt="This image is the cover for the book On Your Knees, The Swoop List"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On Your Knees, The Swoop List
      </h1>
      <p class="bookDescription body article font2">
        <p>When a gang shooting causes tensions to rise, the swoop-list girls must discover how to keep their cool and have faith in each other. Can they maintain their friendship under these stressful circumstances?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Perry Moore
      </h2>
      
      <p class="authorDescription body article"><B>Stephanie Perry Moore</B> was born in South Carolina and now lives with her family in Georgia. She is the author of many YA series, including the <B>Lockwood Lions</B>, the <B>Grovehill Giants</B>, and the<B> Payton Skky</B> series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A division of Lerner Publishing Group, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ff098ffa